;(() => {
  const ATTR = "data-has-value"
  const SELECTOR = "select[data-inner-label]"

  $(() => {
    const changeHasValueAttr = function changeHasValueAttr() {
      const $select = $(this)
      // Waiting for react to render
      setTimeout(() => {
        requestAnimationFrame(() => {
          const hasValue = $select.val()
          if (hasValue) {
            $select.attr(ATTR, true)
          } else {
            $select.removeAttr(ATTR)
          }
        })
      }, 0)
    }

    const init = () => {
      $(`${SELECTOR}:not([inited])`).each(function markInitialized() {
        $(this).attr("inited", true)
        changeHasValueAttr.call(this)
      })
    }

    init()
    $(document).on("change", SELECTOR, changeHasValueAttr)

    if (document.querySelector(".layout-checkout_new")) {
      const observe = (callback) => {
        const observer = new MutationObserver(callback)
        observer.observe(document.documentElement, {
          subtree: true,
          childList: true,
        })
      }

      const throttleInit = HB.throttle(init, 200)
      observe(throttleInit)
    }
  })
})()
